import React from "react";
import { Col, Container, Row } from "reactstrap";
import { P } from "../AbstractElements";
import SvgIcon from "../Utils/CommonComponents/CommonSvgIcons";

export default function Footer() {
  const currentYear = new Date().getFullYear(); // Get current year

  return (
    <footer className="footer">
      <Container fluid>
        <Row>
          <Col md={6} className="footer-copyright">
            <P className="mb-0">{`Copyright ${currentYear} © Fleet Pro`}</P>
          </Col>
          <Col md={6}>
            <P className="float-end mb-0">
              Designed By{" "}
              <a
                href="http://www.logiprompt.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary"
              >
                Logiprompt Techno Solutions India Pvt Ltd
              </a>
              <SvgIcon className="svg-color footer-icon" iconId="heart" />
            </P>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
